import {
  ACCOUNT_CREDIT_METHOD,
  PaymentFormValues
} from "../AllocationForm.types.ts";

export const showAccountCredit = (fields: PaymentFormValues[], index: number) =>
  fields[index].method === ACCOUNT_CREDIT_METHOD ||
  !fields.some(y => y.method === ACCOUNT_CREDIT_METHOD);
